export default "__VITE_ASSET__Cd55cdyC__"